<h1 mat-dialog-title>{{'COMMON.DIALOG.CONFIRMATION_DIALOG.WARNING' | translate}}</h1>
<div mat-dialog-content>
  <p [innerHtml]="message"></p>
</div>
<div mat-dialog-actions>
    <button 
        mat-raised-button color="primary"  class="btn-return"
        cdkFocusInitial
        (click)="dialogRef.close(false)">
        {{'COMMON.DIALOG.CONFIRMATION_DIALOG.NO' | translate}}
    </button>
    <button 
        mat-raised-button color="primary"
        (click)="dialogRef.close(true)">
        {{'COMMON.DIALOG.CONFIRMATION_DIALOG.YES' | translate}}
    </button>
</div>